import get from 'lodash/get';

const getResponsiveAlternative = (asset, alternative) => (
  get(asset, ['alternatives', alternative]) || asset
);
export const hasResponsiveAlternative = (asset, alternative) => (
  alternative === 'Main' || !!get(asset, ['alternatives', alternative, 'sizes', 'length'])
);
const mobileAlternativeName = 'Mobile';
export const getBestAlternativeName = (asset, isSmall) => (
  isSmall && hasResponsiveAlternative(asset, mobileAlternativeName) ? mobileAlternativeName : 'Main'
);
export const getBestAlternative = (asset, isSmall) => (
  getResponsiveAlternative(asset, isSmall && mobileAlternativeName)
);

export default getResponsiveAlternative;



// WEBPACK FOOTER //
// ./src/utils/getResponsiveAlternative.js